import React from 'react';

export function SplashScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #FF6B00 0%, #FF8C00 50%, #FFB347 100%)'}}>
      <div className="text-center">
        {/* Handy Logo */}
        <div className="relative mb-8">
          <div className="w-28 h-28 bg-white rounded-3xl flex items-center justify-center mx-auto shadow-2xl animate-pulse">
            <img src="/handy-logo.svg" alt="Handy" width="80" height="80" />
          </div>
          <div className="absolute inset-0 w-28 h-28 mx-auto">
            <div className="absolute inset-0 rounded-3xl bg-white opacity-20 animate-ping scale-110"></div>
          </div>
        </div>

        <h1 className="text-5xl font-bold text-white mb-3 tracking-tight">Handy</h1>
        <p className="text-orange-100 text-xl font-medium">Handy Blockchain Wallet</p>
        
        <div className="mt-12">
          <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    </div>
  );
}
